import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Home from './Components/Home/Home';
import International from './Components/Navbar/About/International';
import Multiple from './Components/Navbar/About/Multiple';
import A320 from './Components/Navbar/Districts/A320';
import B320 from './Components/Navbar/Districts/B320';
import C320 from './Components/Navbar/Districts/C320';
import D320 from './Components/Navbar/Districts/D320';
import E320 from './Components/Navbar/Districts/E320';
import F320 from './Components/Navbar/Districts/F320';
import G320 from './Components/Navbar/Districts/G320';
import Upload from './Components/Navbar/Upload/Upload';
import Contact from './Components/Navbar/Contact/Contact';
import H320 from './Components/Navbar/Districts/H320';
import MemberEngagement from './Components/MemberEngagement/MemberEngagement';

import './i18n';
import DistrictDetail from './Components/Navbar/About/DistrictDetail';
import AdminLogin from './Components/Adminlogin/adminlogin';

import SchemaAdminModule from './Components/Admin/SchemaAdminModule';
import PublicFormView from './Components/Admin/PublicFormView';
import ResponsesCrudModule from './Components/Admin/ResponsesCrudModule';
import LeadershipDetail from './Components/Navbar/About/LeadershipDetail';


function App() {
  return (
    <div className="App">

      <div>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/international" element={<International />} />
            <Route path="/multiple-districts" element={<Multiple />} />
            <Route path="/district/:id" element={<DistrictDetail />} />
            <Route path="/leadership/:role" element={<LeadershipDetail />} />
            <Route path="/320a" element={<A320 />} />
            <Route path="/320b" element={<B320 />} />
            <Route path="/320c" element={<C320 />} />
            <Route path="/320d" element={<D320 />} />
            <Route path="/320e" element={<E320 />} />
            <Route path="/320f" element={<F320 />} />
            <Route path="/320g" element={<G320 />} />
            <Route path="/320h" element={<H320 />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/upload" element={<Upload />} />

            <Route path="/member/engagement" element={<MemberEngagement />} />
            <Route path="/adminlogin" element={<AdminLogin />} />


            <Route path="/create-form" element={<SchemaAdminModule />} />
            <Route path="/public/form/:formId/:userId" element={<PublicFormView />} />
            <Route path="/admin/responses/:formId" element={<ResponsesCrudModule />} />


            <Route path="/member/engagement" element={<MemberEngagement />} />



          </Routes>
        </BrowserRouter>
      </div>

    </div>
  );
}

export default App;
